import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import UploadFileIcon from '@mui/icons-material/UploadFile';

import { AddFiles } from '../../../Illustrations/AddFiles';
import { GatedButton } from '../../../Access/GatedButton';
import { OPEN } from '../../../Access/utils/access-gate.util';
import type { AccessGate } from '../../../Access/types/access-gate.type';

interface Props {
  readonly onUploadClick: () => void;
  readonly uploadGate?: AccessGate;
}

export const EmptyFiles = ({
  onUploadClick,
  uploadGate = OPEN,
}: Readonly<Props>) => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'center',
      minHeight: '100%',
      p: 2,
    }}
  >
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        textAlign: 'center',
        width: '100%',
      }}
    >
      <AddFiles
        sx={{
          minHeight: 'auto',
          '& svg': { height: 'auto', width: '100%' },
        }}
      />
      <Typography color="text.secondary" variant="body1">
        Aucun fichier dans cette catégorie
      </Typography>
      <GatedButton
        gate={uploadGate}
        onClick={onUploadClick}
        startIcon={<UploadFileIcon />}
        variant="outlined"
      >
        Uploader des fichiers
      </GatedButton>
    </Box>
  </Box>
);
